import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  roleList: [],
}

export const roleListSlice = createSlice({
  name: 'roleListSlice',
  initialState,
  reducers: {
    updateRoleList(state, action) {
      state.roleList = action.payload.roleList
    },
    resetRoleSlice: (state) => initialState,
  },
})
export const roleActions = roleListSlice.actions
export default roleListSlice.reducer
